import { Navigate } from 'react-router-dom';

import { getMfaPendingSession } from '../../helpers/localStorage';

/**
 * Keeps the private layout from mounting while a login is pending MFA.
 *
 * It wraps the layout route element instead of living inside PrivateRoute
 * because the layout (Menu) mounts BEFORE its children can redirect, and on
 * mount it opens a websocket and fetches the unread messages. Redirecting from
 * the child would leave those calls already fired (REAL-3264).
 */
export function MfaGuard({
  children,
}: {
  children: React.ReactElement;
}): JSX.Element {
  if (getMfaPendingSession()) {
    return <Navigate to="/mfa" replace />;
  }

  return children;
}
